module.exports = __webpack_public_path__ + "static/media/Ai.d0993710.svg";